{
  "retry": "أعد المحاولة",
  "tab": {
    "label": "العقد",
    "views": "أقسام العقد",
    "view": {
      "boq": "جدول الكميات",
      "variations": "الأوامر التغييرية",
      "claims": "المستخلصات",
      "retention": "المحتجزات والدفعة المقدمة",
      "bonds": "الضمانات",
      "final": "الحساب الختامي"
    },
    "feature": {
      "boq": "جدول الكميات",
      "variations": "الأوامر التغييرية",
      "progressClaims": "المستخلصات",
      "retention": "المحتجزات",
      "bonds": "الضمانات البنكية"
    },
    "off": "{{name}} متوقف لهذا المشروع في الإعدادات › المشاريع، لذلك لا يظهر هذا الجزء من العقد.",
    "boqOff": "لا يوجد عقد لهذا المشروع: جدول الكميات متوقف له في الإعدادات › المشاريع.",
    "needsPermission": "يعرض تبويب العقد مبالغ مالية، لذا يحتاج إلى إحدى صلاحيتين لا يملكهما دورك: إدارة عقود المشاريع (projects.contract) أو عرض الأموال في المشاريع (projects.financials). اطلب من مسؤول النظام إضافة إحداهما.",
    "claimsSoon": "تظهر هنا مستخلصات هذا العقد.",
    "retentionSoon": "تظهر هنا المحتجزات المستقطعة والمفرج عنها، والدفعة المقدمة واستردادها."
  },
  "contractStatus": {
    "DRAFT": "مسودة",
    "ACTIVE": "سارٍ",
    "COMPLETED": "مستلم",
    "CLOSED": "مقفل"
  },
  "boqStatus": {
    "DRAFT": "مسودة",
    "CONTRACT": "تعاقدي",
    "SUPERSEDED": "مستبدل"
  },
  "variationStatus": {
    "DRAFT": "مسودة",
    "PENDING_APPROVAL": "بانتظار الموافقة",
    "SUBMITTED": "مقدَّم",
    "APPROVED": "معتمد",
    "REJECTED": "مرفوض",
    "WITHDRAWN": "مسحوب"
  },
  "variationKind": {
    "CLIENT_INSTRUCTION": "تعليمات العميل",
    "DESIGN_CHANGE": "تعديل في التصميم",
    "SITE_CONDITION": "ظروف الموقع",
    "PS_EXPENDITURE": "صرف مبلغ احتياطي",
    "OMISSION": "إلغاء أعمال"
  },
  "lineAction": {
    "ADD": "إضافة بند",
    "CHANGE_QTY": "تعديل الكمية",
    "OMIT": "إلغاء"
  },
  "itemKind": {
    "MEASURED": "بالقياس",
    "LUMP_SUM": "مقطوعية",
    "PROVISIONAL_SUM": "مبلغ احتياطي",
    "PRIME_COST": "مبلغ أساسي",
    "DAYWORK": "أعمال يومية",
    "CONTINGENCY": "طوارئ"
  },
  "itemKindHint": {
    "MEASURED": "يُدفع حسب الكمية المنفذة فعلًا بسعر الوحدة.",
    "LUMP_SUM": "سعر واحد للبند كله، يُطالب به بنسبة الإنجاز.",
    "PROVISIONAL_SUM": "مخصص لأعمال لم تُحدد بعد؛ يدخل في قيمة العقد ويُستبدل بأمر تغييري.",
    "PRIME_COST": "مخصص لمواد يختارها العميل؛ يدخل في قيمة العقد.",
    "DAYWORK": "أعمال تُدفع بالوقت والمواد حسب أسعار الأعمال اليومية المتفق عليها.",
    "CONTINGENCY": "مخصص لما لم يكن في الحسبان؛ يدخل في قيمة العقد."
  },
  "measureBy": {
    "QUANTITY": "بالكمية",
    "PERCENT": "بنسبة الإنجاز"
  },
  "measureShort": {
    "QUANTITY": "كمية",
    "PERCENT": "نسبة مئوية"
  },
  "basis": {
    "REMEASURE": "بإعادة القياس",
    "LUMP_SUM": "مقطوعية"
  },
  "basisHint": {
    "REMEASURE": "تُقاس الكميات في الموقع وتُدفع حسب التنفيذ.",
    "LUMP_SUM": "سعر ثابت؛ يُطالب بكل بند بنسبة الإنجاز."
  },
  "recovery": {
    "PRO_RATA": "بالتناسب",
    "FIXED_RATE": "نسبة ثابتة",
    "MANUAL": "حسب الإدخال"
  },
  "stageName": {
    "COMPLETION": "عند الاستلام الابتدائي",
    "DLP_END": "عند نهاية فترة ضمان العيوب",
    "OTHER": "عند مرحلة أخرى متفق عليها"
  },
  "termKey": {
    "contractNumber": "رقم العقد",
    "clientReference": "مرجع العميل",
    "taxRateId": "نسبة ضريبة القيمة المضافة",
    "commencementDate": "تاريخ المباشرة",
    "completionDue": "موعد الإنجاز",
    "paymentDays": "أيام السداد",
    "measureDefault": "طريقة القياس",
    "overMeasure": "القياس فوق الكمية",
    "retentionRatePct": "نسبة المحتجزات",
    "retentionCapPct": "سقف المحتجزات",
    "retentionCapBasis": "أساس السقف",
    "releaseStages": "مراحل الإفراج",
    "dlpMonths": "فترة ضمان العيوب",
    "advancePercent": "الدفعة المقدمة",
    "recovery": "استرداد الدفعة المقدمة",
    "fixedRatePct": "نسبة الاسترداد",
    "startThresholdPct": "بدء الاسترداد عند",
    "thresholdBasis": "أساس حد البدء",
    "ldPerDay": "غرامات التأخير عن كل يوم",
    "ldCapPct": "سقف غرامات التأخير"
  },
  "terms": {
    "heading": {
      "payment": "السداد",
      "measure": "القياس",
      "retention": "المحتجزات",
      "release": "الإفراج",
      "advance": "الدفعة المقدمة",
      "damages": "غرامات التأخير"
    },
    "clause": {
      "paymentNow": "يستحق كل مستخلص في يوم اعتماده من العميل.",
      "payment_zero": "يستحق كل مستخلص في يوم اعتماده من العميل.",
      "payment_one": "يستحق كل مستخلص بعد يوم واحد من اعتماده من العميل.",
      "payment_two": "يستحق كل مستخلص بعد يومين من اعتماده من العميل.",
      "payment_few": "يستحق كل مستخلص بعد {{n}} أيام من اعتماده من العميل.",
      "payment_many": "يستحق كل مستخلص بعد {{n}} يومًا من اعتماده من العميل.",
      "payment_other": "يستحق كل مستخلص بعد {{n}} يوم من اعتماده من العميل.",
      "measure": {
        "QUANTITY": "تُقاس البنود بالكمية المنفذة.",
        "PERCENT": "تُقاس البنود بنسبة الإنجاز."
      },
      "over": {
        "WARN": "يظهر تنبيه عند القياس فوق كمية البند.",
        "BLOCK": "يُرفض القياس فوق كمية البند حتى يغطيه أمر تغييري."
      },
      "retention": "يُحتجز {{rate}} من كل مستخلص بحد أقصى {{cap}} من {{basis}}.",
      "retentionNoCap": "يُحتجز {{rate}} من كل مستخلص دون حد أقصى.",
      "release_zero": "يُفرج عنها {{stages}}؛ ولا توجد فترة ضمان عيوب بعد الاستلام الابتدائي.",
      "release_one": "يُفرج عنها {{stages}}؛ وفترة ضمان العيوب شهر واحد من الاستلام الابتدائي.",
      "release_two": "يُفرج عنها {{stages}}؛ وفترة ضمان العيوب شهران من الاستلام الابتدائي.",
      "release_few": "يُفرج عنها {{stages}}؛ وفترة ضمان العيوب {{n}} أشهر من الاستلام الابتدائي.",
      "release_many": "يُفرج عنها {{stages}}؛ وفترة ضمان العيوب {{n}} شهرًا من الاستلام الابتدائي.",
      "release_other": "يُفرج عنها {{stages}}؛ وفترة ضمان العيوب {{n}} شهر من الاستلام الابتدائي.",
      "advance": {
        "PRO_RATA": "دفعة مقدمة بنسبة {{percent}} من قيمة العقد الأصلية، تُسترد من كل مستخلص بنسبة الأعمال المعتمدة فيه.",
        "FIXED_RATE": "دفعة مقدمة بنسبة {{percent}} من قيمة العقد الأصلية، تُسترد بنسبة {{rate}} من كل مستخلص بعد اعتماد {{threshold}} من {{basis}}.",
        "MANUAL": "دفعة مقدمة بنسبة {{percent}} من قيمة العقد الأصلية، تُسترد بالمبلغ المدخل في كل مستخلص."
      },
      "damages": "غرامات التأخير {{amount}} عن كل يوم، بحد أقصى {{cap}} من قيمة العقد.",
      "damagesNoCap": "غرامات التأخير {{amount}} عن كل يوم، دون حد أقصى.",
      "damagesNone": "لا توجد غرامات تأخير محددة."
    },
    "stage": {
      "COMPLETION": "{{percent}} عند الاستلام الابتدائي",
      "DLP_END": "{{percent}} عند نهاية فترة ضمان العيوب",
      "OTHER": "{{percent}} عند مرحلة أخرى متفق عليها"
    },
    "capBasis": {
      "ORIGINAL": "قيمة العقد الأصلية",
      "CURRENT": "قيمة العقد الحالية"
    },
    "thresholdBasis": {
      "ORIGINAL": "قيمة العقد الأصلية",
      "ORIGINAL_LESS_PROVISIONAL": "قيمة العقد الأصلية دون المبالغ الاحتياطية"
    }
  },
  "form": {
    "contractGroup": "العقد",
    "contractNumber": "رقم العقد",
    "clientReference": "مرجع العميل",
    "taxRate": "نسبة ضريبة القيمة المضافة",
    "taxHint": "نسبة واحدة لكل مستخلصات هذا العقد.",
    "taxLocked": "ثابتة: اعتُمد مستخلص بهذه النسبة.",
    "taxPlaceholder": "اختر نسبة الضريبة",
    "commencement": "تاريخ المباشرة",
    "completionDue": "موعد الإنجاز",
    "completionHint": "تمدده الأوامر التغييرية المعتمدة بمدتها الزمنية بالأيام التقويمية.",
    "measureDefault": "طريقة قياس البنود",
    "measureHint": {
      "QUANTITY": "يُدخل في كل مستخلص ما نُفذ من الكمية حتى تاريخه.",
      "PERCENT": "يُدخل في كل مستخلص نسبة الإنجاز حتى تاريخه."
    },
    "overMeasure": "القياس فوق كمية البند",
    "overMeasureName": {
      "WARN": "تنبيه",
      "BLOCK": "رفض"
    },
    "overMeasureHint": {
      "WARN": "يُحفظ المستخلص مع تنبيه على البند.",
      "BLOCK": "لا يُحفظ المستخلص حتى يضيف أمر تغييري الكمية."
    },
    "paymentDays": "السداد بعد الاعتماد",
    "days": "يوم",
    "months": "شهر",
    "retentionRate": "يُحتجز من كل مستخلص",
    "retentionCap": "بحد أقصى",
    "noCap": "دون سقف",
    "noCapToggle": "لا سقف للمحتجزات",
    "capBasis": "من",
    "capBasisName": {
      "ORIGINAL": "قيمة العقد الأصلية",
      "CURRENT": "قيمة العقد الحالية"
    },
    "releaseStages": "الإفراج",
    "stage": "متى",
    "stageN": "متى، المرحلة {{n}}",
    "stagePercent": "النسبة",
    "stagePercentN": "النسبة، المرحلة {{n}}",
    "removeStage": "حذف المرحلة {{n}}",
    "addStage": "إضافة مرحلة",
    "stagesComplete": "مجموع المراحل 100%.",
    "stagesTotal": "مجموع المراحل {{total}}؛ ويجب أن يكون 100%.",
    "dlpMonths": "فترة ضمان العيوب",
    "dlpHint": "من تاريخ الاستلام الابتدائي؛ وتستحق آخر مرحلة من المحتجزات بنهايتها.",
    "advancePercent": "الدفعة المقدمة من قيمة العقد الأصلية",
    "recovery": "طريقة استرداد الدفعة المقدمة",
    "recoveryHint": {
      "PRO_RATA": "يسترد كل مستخلص من الدفعة المقدمة النسبة المئوية نفسها التي يعتمدها من الأعمال.",
      "FIXED_RATE": "نسبة ثابتة من كل مستخلص بعد بلوغ حد معين (على نمط فيديك).",
      "MANUAL": "يُدخل المبلغ في كل مستخلص."
    },
    "fixedRate": "يُسترد من كل مستخلص",
    "startThreshold": "يبدأ عندما تبلغ الأعمال المعتمدة",
    "thresholdBasis": "من",
    "thresholdBasisName": {
      "ORIGINAL": "قيمة العقد الأصلية",
      "ORIGINAL_LESS_PROVISIONAL": "قيمة العقد الأصلية دون المبالغ الاحتياطية (فيديك 1999)"
    },
    "ldPerDay": "غرامات التأخير عن كل يوم",
    "ldHint": "تُستخدم فقط لاقتراح مبلغ في المستخلص؛ اتركها فارغة إن لم توجد.",
    "ldCap": "بحد أقصى من قيمة العقد",
    "none": "لا يوجد",
    "required": "مطلوب",
    "error": {
      "days": "أدخل عدد أيام صحيحًا من 0 إلى 365.",
      "months": "أدخل عدد أشهر صحيحًا من 0 إلى 60.",
      "percent": "أدخل نسبة من 0 إلى 100، بأربع خانات عشرية كحد أقصى.",
      "stages": "حدد من مرحلة إلى أربع مراحل مجموعها 100%.",
      "amount": "أدخل مبلغًا يساوي صفرًا أو أكثر، بثلاث خانات عشرية كحد أقصى.",
      "taxRate": "اختر نسبة الضريبة.",
      "invalid": "تحقق من هذه القيمة."
    }
  },
  "header": {
    "title": "العقد",
    "actions": "إجراءات العقد",
    "number": "رقم {{number}}",
    "clientRef": "مرجع العميل {{ref}}",
    "vat": "ضريبة القيمة المضافة {{rate}}",
    "boq": "جدول الكميات: {{name}}",
    "reviewTerms": "مراجعة الشروط",
    "editTerms": "تعديل الشروط",
    "editTermsBody": "شروط مسودة العقد. يمكن تغييرها بحرية حتى تفعيل العقد.",
    "newTermsBody": "يبدأ العقد من إعدادات المقاولات الافتراضية لشركتك. الحفظ ينشئ مسودة العقد.",
    "saveTerms": "حفظ الشروط",
    "activate": "تفعيل العقد",
    "amend": "تعديل الشروط بملحق",
    "completion": "تسجيل الاستلام الابتدائي",
    "more": "المزيد",
    "draftNew": "لا يوجد عقد بعد. هذه إعدادات المقاولات الافتراضية لشركتك: راجعها لبدء مسودة العقد، ثم فعّله بإصدار من جدول الكميات.",
    "draftBody": "مسودة عقد. يمكن تغيير الشروط بحرية؛ فعّل العقد بإصدار من جدول الكميات لبدء المستخلصات.",
    "draftReadOnly": "مسودة عقد: الشروط أدناه غير سارية بعد.",
    "terms": "الشروط",
    "amendedCount": "· الملاحق: {{n}}، آخرها {{date}}",
    "toast": {
      "termsSaved": "حُفظت الشروط",
      "activated": "فُعّل العقد",
      "amended": "عُدّلت الشروط",
      "completed": "سُجّل الاستلام الابتدائي"
    }
  },
  "sum": {
    "label": "قيمة العقد",
    "original": "القيمة الأصلية",
    "approved": "الأوامر التغييرية المعتمدة",
    "current": "القيمة الحالية",
    "pending": "أوامر تغييرية معلقة {{amount}} (لا تدخل في القيمة حتى تُعتمد)"
  },
  "position": {
    "label": "الموقف المالي للعقد",
    "certified": "المعتمد حتى تاريخه",
    "certifiedSub": "{{percent}} من القيمة الحالية",
    "outstanding": "المستحق",
    "outstandingSub": "مفوتر ولم يُحصّل بعد",
    "retention": "المحتجزات القائمة",
    "retentionSub": "أُفرج عن {{released}}",
    "advance": "الدفعة المقدمة المتبقية",
    "advanceSub": "من دفعة مقدمة قدرها {{invoiced}}",
    "invoiced": "المفوتر",
    "invoicedSub": "المستخلصات والدفعة المقدمة والإفراجات، شاملة الضريبة",
    "received": "المحصّل",
    "receivedSub": "المخصص لفواتير العقد"
  },
  "dates": {
    "commenced": "المباشرة {{date}}",
    "due": "موعد الإنجاز {{date}}",
    "completed": "الاستلام الابتدائي {{date}}",
    "dlp": "تنتهي فترة ضمان العيوب {{date}}",
    "dlpPlanned": "تنتهي فترة ضمان العيوب {{date}} (مخطط)"
  },
  "activate": {
    "title": "تفعيل العقد",
    "body": "اختر إصدار جدول الكميات الذي وقّعه العميل. يصبح جدول العقد ويُجمَّد؛ وبعدها لا يتغير العقد إلا بأوامر تغييرية.",
    "version": "إصدار جدول الكميات",
    "versionLine": "عدد البنود: {{n}} · {{total}}",
    "consequence": "يصبح «{{name}}» جدول كميات العقد، وتكون القيمة الأصلية {{total}}، وتُحفظ المسودات الأخرى بصفة مستبدلة.",
    "confirm": "تفعيل العقد",
    "customerHint": "أضف العميل إلى المشروع (تعديل المشروع)، ثم فعّل العقد.",
    "boqHint": "أضف إصدارًا من جدول الكميات فيه بند واحد على الأقل، ثم فعّل العقد."
  },
  "amend": {
    "title": "تعديل الشروط بملحق",
    "body": "غيّر شروط العقد السارية. تُحسب الاستقطاعات تراكميًا، فتُسوّى النسبة أو الطريقة الجديدة في المستخلص التالي؛ ولا يتغير شيء مما اعتُمد.",
    "reason": "سبب تعديل الشروط",
    "reasonRequired": "اذكر السبب: يُحفظ مع الملحق ويُطبع في المستخلص التالي.",
    "changes": "التغييرات: {{n}}",
    "changed": "سيتغير: {{fields}}",
    "confirm": "اعتماد الملحق",
    "history": "الملاحق",
    "line": "{{date}} · {{by}}",
    "system": "النظام",
    "change": "{{field}}: {{from}} ← {{to}}"
  },
  "completion": {
    "title": "تسجيل الاستلام الابتدائي",
    "body": "تاريخ تسلم العميل للأعمال. يصبح العقد مستلمًا وتبدأ فترة ضمان العيوب.",
    "date": "تاريخ الاستلام الابتدائي",
    "consequence_zero": "لا توجد فترة ضمان عيوب ({{date}})، وتستحق مرحلة المحتجزات عند الاستلام الابتدائي.",
    "consequence_one": "تنتهي فترة ضمان العيوب (شهر واحد) في {{date}}، وتستحق مرحلة المحتجزات عند الاستلام الابتدائي.",
    "consequence_two": "تنتهي فترة ضمان العيوب (شهران) في {{date}}، وتستحق مرحلة المحتجزات عند الاستلام الابتدائي.",
    "consequence_few": "تنتهي فترة ضمان العيوب ({{n}} أشهر) في {{date}}، وتستحق مرحلة المحتجزات عند الاستلام الابتدائي.",
    "consequence_many": "تنتهي فترة ضمان العيوب ({{n}} شهرًا) في {{date}}، وتستحق مرحلة المحتجزات عند الاستلام الابتدائي.",
    "consequence_other": "تنتهي فترة ضمان العيوب ({{n}} شهر) في {{date}}، وتستحق مرحلة المحتجزات عند الاستلام الابتدائي.",
    "consequenceNoRetention_zero": "لا توجد فترة ضمان عيوب ({{date}}).",
    "consequenceNoRetention_one": "تنتهي فترة ضمان العيوب (شهر واحد) في {{date}}.",
    "consequenceNoRetention_two": "تنتهي فترة ضمان العيوب (شهران) في {{date}}.",
    "consequenceNoRetention_few": "تنتهي فترة ضمان العيوب ({{n}} أشهر) في {{date}}.",
    "consequenceNoRetention_many": "تنتهي فترة ضمان العيوب ({{n}} شهرًا) في {{date}}.",
    "consequenceNoRetention_other": "تنتهي فترة ضمان العيوب ({{n}} شهر) في {{date}}.",
    "confirm": "تسجيل الاستلام الابتدائي"
  },
  "step": {
    "submit": "تقديم مسودة المستخلص",
    "certify": "اعتماد {{number}}",
    "release": "الإفراج عن المحتجزات",
    "newClaim": "مستخلص جديد"
  },
  "boq": {
    "version": "إصدار جدول الكميات",
    "versionContract": "تعاقدي · {{date}}",
    "current": "جدول الكميات الحالي (مع الأوامر التغييرية)",
    "versionLine": "عدد البنود: {{n}} · {{total}} · {{basis}}",
    "actions": "إجراءات جدول الكميات",
    "descriptionLang": "لغة الوصف",
    "lang": {
      "en": "EN",
      "ar": "ع"
    },
    "addSection": "إضافة قسم",
    "addItem": "إضافة بند",
    "import": "استيراد CSV",
    "more": "المزيد",
    "newVersion": "إصدار جديد لجدول الكميات",
    "newBody": "مسودة فارغة: أضف البنود أو استورد ملف CSV، أو انسخ إصدارًا آخر بدلًا من ذلك.",
    "firstName": "جدول كميات المناقصة",
    "copy": "نسخ هذا الإصدار",
    "copyTitle": "نسخ «{{name}}»",
    "copyBody": "مسودة جديدة بالأقسام والبنود نفسها لتسعير بديل.",
    "copyName": "{{name}} (نسخة)",
    "copyConfirm": "نسخ الإصدار",
    "createConfirm": "إنشاء الإصدار",
    "versionName": "الاسم",
    "basis": "الأساس",
    "export": "تصدير CSV",
    "exportFailed": "تعذر تنزيل ملف CSV. أعد المحاولة.",
    "budget": "إنشاء موازنة من جدول الكميات",
    "deleteDraft": "حذف المسودة",
    "deleteTitle": "حذف «{{name}}»؟",
    "deleteBody": "تُحذف المسودة وكل بنودها ({{n}}). لا يتأثر العقد ولا الإصدارات الأخرى.",
    "frozenContract": "هذا الإصدار هو جدول العقد وهو مجمَّد. تتم التغييرات عبر الأوامر التغييرية.",
    "frozenSuperseded": "استُبدل عند تفعيل العقد؛ ويُحتفظ به للرجوع إليه.",
    "loadFailed": "تعذر تحميل جدول الكميات.",
    "tableLabel": "جدول الكميات: {{name}}",
    "totalLine": "عدد البنود: {{n}} · الإجمالي",
    "marginLine": "الهامش {{amount}}",
    "currentTotal": "القيمة الحالية {{amount}}",
    "certifiedTotal": "المعتمد {{amount}}",
    "empty": {
      "title": "لا يوجد جدول كميات بعد",
      "body": "ابدأ إصدارًا ثم أضف أبوابه وبنوده أو استوردها من ملف CSV.",
      "readOnly": "تظهر هنا بنود العقد المسعّرة عندما يضيفها مسؤول العقود."
    },
    "noItems": {
      "title": "لا توجد بنود في هذا الإصدار",
      "body": "أضف قسمًا وبنوده، أو استوردها من ملف CSV.",
      "readOnly": "لم يُسعَّر شيء في هذا الإصدار."
    },
    "col": {
      "itemNo": "البند",
      "description": "الوصف",
      "unit": "الوحدة",
      "quantity": "الكمية",
      "currentQty": "الكمية الحالية",
      "rate": "سعر الوحدة",
      "amount": "المبلغ",
      "kind": "النوع",
      "measureBy": "القياس",
      "wbs": "الخطة",
      "category": "فئة التكلفة",
      "costRate": "سعر التكلفة",
      "margin": "الهامش",
      "certifiedPct": "نسبة المعتمد",
      "certifiedValue": "المعتمد"
    },
    "toast": {
      "created": "أُنشئ إصدار جدول الكميات",
      "copied": "نُسخ إصدار جدول الكميات",
      "deleted": "حُذفت المسودة"
    }
  },
  "section": {
    "newTitle": "إضافة قسم",
    "editTitle": "القسم {{code}}",
    "body": "الباب أو القسم يجمع البنود؛ وإجماليه مجموع ما تحته.",
    "code": "الرمز",
    "parent": "تحت",
    "top": "المستوى الأعلى (باب)",
    "title": "العنوان",
    "titleAr": "العنوان بالعربية",
    "add": "إضافة القسم",
    "save": "حفظ القسم",
    "delete": "حذف القسم",
    "deleteTitle": "حذف القسم {{code}}؟",
    "deleteBody": "يُحذف القسم من هذه المسودة. يجب نقل البنود والأقسام التي تحته أو حذفها أولًا.",
    "toast": {
      "added": "أُضيف القسم",
      "saved": "حُفظ القسم",
      "deleted": "حُذف القسم"
    }
  },
  "item": {
    "newTitle": "إضافة بند",
    "editTitle": "البند {{itemNo}}",
    "body": "في «{{name}}». المبلغ = الكمية × سعر الوحدة، مقربًا إلى البيسة.",
    "itemNo": "رقم البند",
    "section": "القسم",
    "noSection": "بدون قسم",
    "description": "الوصف",
    "descriptionAr": "الوصف بالعربية",
    "unit": "الوحدة",
    "quantity": "الكمية",
    "rate": "سعر الوحدة",
    "rateHint": "الصفر يعني أنه مشمول في بند آخر.",
    "amount": "المبلغ",
    "kind": "النوع",
    "measureBy": "القياس",
    "costGroup": "التكلفة",
    "wbs": "جزء الخطة",
    "category": "فئة التكلفة",
    "noCategory": "لا يوجد",
    "costRate": "سعر التكلفة",
    "costRateHint": "التكلفة المتوقعة للوحدة: يُحسب منها الهامش والموازنة من جدول الكميات.",
    "margin": "الهامش",
    "add": "إضافة البند",
    "save": "حفظ البند",
    "delete": "حذف البند",
    "deleteTitle": "حذف البند {{itemNo}}؟",
    "deleteBody": "يُحذف البند من مسودة الإصدار هذه.",
    "error": {
      "quantity": "أدخل كمية أكبر من صفر."
    },
    "toast": {
      "added": "أُضيف البند",
      "saved": "حُفظ البند",
      "deleted": "حُذف البند"
    }
  },
  "import": {
    "title": "استيراد CSV إلى «{{name}}»",
    "body": "تُطابق البنود برقم البند: يُضاف الجديد ويُحدَّث المعدل وتُنشأ الأقسام من مسار القسم. لا يتغير شيء حتى تعتمد الاستيراد.",
    "file": "ملف CSV",
    "choose": "اختر ملف CSV",
    "chooseAnother": "اختر ملفًا آخر",
    "template": "تنزيل النموذج",
    "columns": "الأعمدة بهذا الترتيب: {{columns}}. يجب أن يساوي المبلغ الكمية × سعر الوحدة.",
    "kinds": "النوع: {{kinds}}. إن تُرك فارغًا فهو بالقياس.",
    "measures": "القياس: {{measures}}. إن تُرك فارغًا يُؤخذ الافتراضي في العقد.",
    "unchanged": "البنود غير الموجودة في الملف تبقى كما هي.",
    "excel": "احفظ ملفات Excel بصيغة “CSV UTF-8” ليبقى النص العربي مقروءًا.",
    "totalBlocked": "الإجمالي الآن {{total}}. يظهر الإجمالي بعد الاستيراد بعد تصحيح الصفوف أدناه.",
    "sending": "جارٍ رفع الملف…",
    "previewing": "جارٍ فحص الملف…",
    "summary": "ما سيفعله الاستيراد",
    "count": {
      "create": "بنود جديدة",
      "update": "معدلة",
      "unchanged": "دون تغيير",
      "sections": "أقسام جديدة",
      "errors": "صفوف بها أخطاء"
    },
    "totalBefore": "الإجمالي الآن",
    "totalAfter": "بعد الاستيراد",
    "errorsTitle": "صفوف يجب تصحيحها: {{n}}",
    "errorsBody": "صحح هذه الصفوف في الملف ثم اختره من جديد. لا يمكن اعتماد ملف فيه أخطاء.",
    "errorsTable": "الصفوف التي بها أخطاء",
    "row": "الصف",
    "column": "العمود",
    "problem": "المشكلة",
    "nothing": "الملف مطابق لهذا الإصدار: لا شيء يتغير.",
    "staleTitle": "تغير الإصدار منذ هذه المعاينة",
    "staleBody": "عدّل أحدهم جدول الكميات بعد فحص الملف. عاين الملف من جديد لترى ما سيفعله الاستيراد الآن.",
    "previewAgain": "معاينة من جديد",
    "applyShort": "اعتماد الاستيراد",
    "apply_zero": "لا تغييرات للاعتماد",
    "apply_one": "اعتماد تغيير واحد",
    "apply_two": "اعتماد تغييرين",
    "apply_few": "اعتماد {{n}} تغييرات",
    "apply_many": "اعتماد {{n}} تغييرًا",
    "apply_other": "اعتماد {{n}} تغيير",
    "applied_zero": "لم يُستورد أي بند",
    "applied_one": "استُورد بند واحد",
    "applied_two": "استُورد بندان",
    "applied_few": "استُوردت {{n}} بنود",
    "applied_many": "استُورد {{n}} بندًا",
    "applied_other": "استُورد {{n}} بند"
  },
  "budget": {
    "title": "إنشاء موازنة من جدول الكميات",
    "body": "يقترح إصدار موازنة جديدًا من «{{name}}»: الكمية × سعر التكلفة، حسب جزء الخطة وفئة التكلفة، ويحل محل تلك الخلايا في الموازنة المعتمدة وتبقى الخلايا الأخرى. ثم يمر باعتماد الموازنة المعتاد. البنود بلا جزء من الخطة تُحمَّل على المشروع ككل.",
    "alreadyOpen": "يوجد إصدار موازنة آخر قيد الإعداد أو بانتظار الاعتماد. قدّمه أو اعتمده أو احذفه من تبويب الموازنة والتكلفة، ثم أعد الإنشاء.",
    "nothing": "لا يوجد بند له فئة تكلفة وسعر تكلفة معًا. أضفهما إلى البنود، ثم أعد الإنشاء.",
    "confirm": "اقتراح الموازنة",
    "resultTitle": "اقتُرح إصدار الموازنة {{n}}",
    "resultBody": "إجمالي التكلفة {{total}}. راجعه وقدّمه من تبويب الموازنة والتكلفة.",
    "noneSkipped": "لكل البنود فئة تكلفة وسعر تكلفة.",
    "skipped": "بنود مستبعدة ({{n}}): ليس لها فئة تكلفة أو سعر تكلفة.",
    "reason": {
      "NO_CATEGORY": "بلا فئة تكلفة",
      "NO_COST_RATE": "بلا سعر تكلفة"
    },
    "open": "فتح الموازنة"
  },
  "variations": {
    "label": "الأوامر التغييرية",
    "count": "الأوامر التغييرية: {{n}}",
    "approvedTotal": "المعتمد {{amount}}",
    "pendingTotal": "المعلق {{amount}}",
    "new": "أمر تغييري جديد",
    "needsActive": "تبدأ الأوامر التغييرية بعد تفعيل العقد.",
    "lines": "البنود: {{n}}",
    "days_zero": "بلا تمديد",
    "days_one": "تمديد يوم واحد",
    "days_two": "تمديد يومين",
    "days_few": "تمديد {{n}} أيام",
    "days_many": "تمديد {{n}} يومًا",
    "days_other": "تمديد {{n}} يوم",
    "empty": {
      "title": "لا توجد أوامر تغييرية",
      "body": "سجّل أمرًا تغييريًا عندما يطلب العميل إضافة أعمال أو تعديلها أو إلغاءها.",
      "readOnly": "تظهر هنا الأوامر التغييرية على هذا العقد."
    },
    "col": {
      "number": "الرقم",
      "title": "الأمر التغييري",
      "status": "الحالة",
      "value": "القيمة",
      "time": "المدة",
      "clientRef": "مرجع العميل",
      "date": "التاريخ"
    }
  },
  "variation": {
    "loading": "أمر تغييري",
    "newTitle": "أمر تغييري جديد",
    "newBody": "يُرقَّم VO-… عند إنشائه. لا يغير شيئًا حتى يعتمده العميل.",
    "editTitle": "{{number}} · مسودة",
    "draftBody": "مسودة: عدّلها بحرية ثم قدّمها للعميل.",
    "title": "العنوان",
    "kind": "النوع",
    "description": "الوصف",
    "instructionRef": "مرجع التعليمات",
    "instructionDate": "تاريخ التعليمات",
    "timeImpact": "الأثر الزمني",
    "costEstimate": "التكلفة المتوقعة",
    "costEstimateHint": "لتعديل الموازنة إذا لم يكن للبنود سعر تكلفة.",
    "lines": "البنود",
    "addLine": "إضافة بند",
    "removeLine": "حذف البند {{n}}",
    "action": "التغيير",
    "actionN": "التغيير، البند {{n}}",
    "target": "بند جدول الكميات",
    "targetN": "بند جدول الكميات، البند {{n}}",
    "targetPlaceholder": "اختر البند الذي يغيره",
    "targetSearch": "ابحث برقم البند أو وصفه",
    "targetEmpty": "لا يوجد بند مطابق",
    "item": "البند",
    "itemNo": "رقم البند",
    "itemNoHint": "VO1.1",
    "unit": "الوحدة",
    "lineDescription": "وصف البند الجديد",
    "quantity": "الكمية",
    "quantityN": "الكمية، البند {{n}}",
    "omitQty": "الكمية الملغاة",
    "changeQty": "التغيير (±)",
    "changeQtyHint": "بالسالب للتخفيض.",
    "starRate": "بسعر مستحدث",
    "starRateShort": "سعر مستحدث",
    "starRateValue": "السعر المستحدث",
    "rate": "سعر الوحدة",
    "rateN": "سعر الوحدة، البند {{n}}",
    "atRate": "بسعر البند {{rate}}",
    "amount": "المبلغ",
    "value": "القيمة",
    "belowCertified": "هذا ينزل بالبند {{itemNo}} عن الكمية المعتمدة حتى الآن ({{certified}} {{unit}}).",
    "save": "حفظ المسودة",
    "create": "إنشاء المسودة",
    "submit": "تقديم للعميل",
    "withdraw": "سحب",
    "withdrawTitle": "سحب {{number}}؟",
    "withdrawBody": "يُحتفظ بالأمر التغييري برقمه ويُعلَّم مسحوبًا؛ ولا يغير العقد أبدًا.",
    "reject": "تسجيل الرفض",
    "rejectTitle": "تسجيل رفض العميل لـ {{number}}",
    "rejectBody": "يُحتفظ بالأمر التغييري ويُعلَّم مرفوضًا؛ ولا يتغير العقد.",
    "decide": "تسجيل قرار العميل",
    "reason": "السبب",
    "submittedValue": "القيمة المقدمة",
    "approvedValue": "القيمة المعتمدة",
    "approvedAmount": "المعتمد",
    "clientRef": "مرجع العميل",
    "decidedOn": "تاريخ القرار",
    "reasonTitle": {
      "REJECTED": "رفضه العميل",
      "WITHDRAWN": "مسحوب"
    },
    "error": {
      "target": "اختر بند جدول الكميات الذي يغيره هذا البند.",
      "addItem": "حدد رقم البند الجديد ووصفه ووحدته.",
      "positive": "أدخل كمية أكبر من صفر.",
      "quantity": "أدخل كمية لا تساوي صفرًا.",
      "lines": "أضف بندًا واحدًا على الأقل.",
      "decisionLines": "حدد لكل بند كمية وسعرًا معتمدين."
    },
    "toast": {
      "created": "أُنشئ {{number}}",
      "saved": "حُفظ الأمر التغييري",
      "submitted": "قُدّم {{number}}",
      "withdrawn": "سُحب {{number}}",
      "rejected": "رُفض {{number}}",
      "approved": "اعتُمد {{number}}"
    }
  },
  "decision": {
    "title": "تسجيل قرار العميل بشأن {{number}}",
    "body": "الكمية والسعر المعتمدان لكل بند، كما قُدّما ما لم يغيرهما العميل. الاعتماد يغير قيمة العقد وموعد الإنجاز، ويضيف التكلفة إلى الموازنة (إلا إذا كان إصدار موازنة آخر مفتوحًا).",
    "clientRef": "مرجع العميل",
    "decidedOn": "تاريخ الاعتماد",
    "lines": "البنود المعتمدة",
    "submitted": "المقدَّم",
    "approvedQty": "الكمية المعتمدة",
    "approvedRate": "السعر المعتمد",
    "approvedQtyFor": "الكمية المعتمدة، {{item}}",
    "approvedRateFor": "السعر المعتمد، {{item}}",
    "total": "القيمة المعتمدة",
    "differs": "(المقدَّم {{submitted}})",
    "time_zero": "لا يتغير موعد الإنجاز.",
    "time_one": "يتأخر موعد الإنجاز يومًا واحدًا.",
    "time_two": "يتأخر موعد الإنجاز يومين.",
    "time_few": "يتأخر موعد الإنجاز {{n}} أيام.",
    "time_many": "يتأخر موعد الإنجاز {{n}} يومًا.",
    "time_other": "يتأخر موعد الإنجاز {{n}} يوم.",
    "confirm": "اعتماد الأمر التغييري"
  },
  "settings": {
    "intro": "يبدأ كل عقد جديد من هذه الشروط ويمكن تغييرها ما دام مسودة. أما العقد الساري فيحتفظ بشروطه، وتُعدَّل بملحق من صفحة العقد.",
    "off": "جدول الكميات متوقف في الإعدادات › المشاريع، فلا يستخدم أي مشروع هذه الشروط بعد.",
    "assumption": "أرقام المحتجزات والدفعة المقدمة والضريبة هنا ممارسة شائعة في عُمان وليست استشارة موثقة: راجعها مع محاسبك.",
    "save": "حفظ إعدادات المقاولات",
    "fix": "بعض القيم تحتاج إلى تصحيح (موضحة أعلاه).",
    "conflict": "غيّر شخص آخر هذه الإعدادات في الأثناء. أعد التحميل لترى نسخته.",
    "reload": "إعادة التحميل",
    "toast": {
      "saved": "حُفظت إعدادات المقاولات"
    },
    "approval": {
      "title": "الموافقة الداخلية",
      "body": "هل يحتاج الأمر التغييري أو المستخلص إلى موافقة داخل الشركة قبل تقديمه إلى العميل.",
      "NONE": "مباشرة إلى العميل",
      "WORKFLOW": "الموافقة أولًا",
      "variations": {
        "NONE": "التقديم يرسل الأمر التغييري إلى العميل فورًا.",
        "WORKFLOW": "التقديم يرسله للموافقة؛ والموافقة الأخيرة ترسله إلى العميل."
      },
      "claims": {
        "NONE": "التقديم يرقّم المستخلص ويرسله إلى العميل فورًا.",
        "WORKFLOW": "التقديم يرسله للموافقة؛ والموافقة الأخيرة ترقّمه وترسله إلى العميل."
      },
      "variationsLabel": "الأوامر التغييرية",
      "claimsLabel": "المستخلصات",
      "fourEyes": "يقرر مسار موافقة الأوامر التغييرية أو المستخلصات متى انطبق؛ وإلا يوافق عليه شخص ثانٍ لديه صلاحية الموافقة على مستندات العقود (مبدأ الشخصين)."
    },
    "guarantees": {
      "title": "الضمانات",
      "reminders": "التذكير قبل الانتهاء (بالأيام)",
      "remindersHint": "حتى خمس قيم تفصل بينها فواصل، مثل 30, 14, 7. من يُبلَّغ ومتى: في كل يوم من هذه الأيام قبل انتهاء الضمان يصل إشعار إلى مدير المشروع ومن يديرون عقده. أما متى يظهر التنبيه على المشروع فيُضبط في مؤشرات المشاريع › اقتراب انتهاء الضمان.",
      "remindersInvalid": "أدخل حتى خمسة أعداد صحيحة من الأيام بين 1 و365 تفصل بينها فواصل.",
      "bondPct": "نسبة ضمان حسن التنفيذ المعتادة",
      "bondPctHint": "من القيمة الحالية للعقد؛ تُقترح عند إضافة ضمان حسن التنفيذ.",
      "bondPctInvalid": "أدخل نسبة بين 0 و100."
    }
  },
  "features": {
    "needs": "يعمل مع: {{names}}.",
    "broken": "يحتاج إلى {{names}}: فعّله أيضًا، أو أوقف هذا.",
    "brokenNamed": "{{feature}} يحتاج إلى {{names}}: فعّله أيضًا، أو أوقف {{feature}}."
  },
  "errors": {
    "FEATURE_REQUIRES": "يحتاج هذا إلى وظيفة أخرى متوقفة. فعّلها في الإعدادات › المشاريع.",
    "CONTRACT_ACTIVE": "العقد مفعّل بالفعل: عدّل شروطه بملحق.",
    "CONTRACT_NOT_ACTIVE": "العقد غير مفعّل بعد. فعّله أولًا.",
    "BOQ_REQUIRED": "يحتاج التفعيل إلى مسودة جدول كميات فيها بند واحد على الأقل.",
    "CUSTOMER_REQUIRED": "يحتاج التفعيل إلى عميل على المشروع.",
    "BOQ_FROZEN": "إصدار جدول الكميات هذا مجمَّد. التغييرات بعد التفعيل تتم بأوامر تغييرية.",
    "IMPORT_STALE": "تغير جدول الكميات منذ المعاينة. عاين الملف من جديد.",
    "VARIATION_FROZEN": "هذا الأمر التغييري مقدَّم أو مقرَّر ولا يمكن تغييره. أنشئ أمرًا تغييريًا جديدًا.",
    "BELOW_CERTIFIED": "أحد البنود ينزل بالكمية عما اعتُمد حتى الآن. خفّض بمقدار أقل.",
    "CLAIM_OPEN": "يوجد مستخلص مفتوح على هذا العقد. أنهه أولًا.",
    "FINAL_CERTIFIED": "اعتُمد المستخلص الختامي: لا مستخلصات أخرى على هذا العقد.",
    "CLAIM_NOT_SUBMITTED": "يجب تقديم المستخلص أولًا.",
    "OVER_MEASURE": "أحد البنود مقاس فوق كميته. صححه أو أضف أمرًا تغييريًا.",
    "PERCENT_OVER_100": "أحد البنود مطالب به فوق 100%.",
    "OVERRIDE_REASON_REQUIRED": "اذكر سببًا لكل رقم تعدّله يدويًا.",
    "NEGATIVE_CERTIFICATE": "سيكون هذا المستخلص سالبًا. راجع الأرقام.",
    "RETENTION_BELOW_RELEASED": "ستنزل المحتجزات عما أُفرج عنه.",
    "CLAIM_NOT_DRAFT": "لا يُعدّل أو يُحذف إلا المستخلص المسودة.",
    "CLAIM_NOT_CERTIFIED": "لا يُلغى إلا المستخلص المعتمد.",
    "RECOVERY_ABOVE_ADVANCE": "سيزيد المسترد حتى تاريخه على الدفعة المقدمة المفوترة.",
    "RETENTION_ABOVE_GROSS": "ستزيد المحتجزات حتى تاريخه على الأعمال المعتمدة.",
    "CERTIFICATE_DATE_ORDER": "لا يمكن أن يكون التاريخ في المستقبل أو قبل آخر مستخلص.",
    "CLAIM_NOT_LATEST": "لا يُلغى إلا آخر مستخلص معتمد.",
    "CLAIM_HAS_LATER": "يوجد مستخلص لاحق. ألغه أو احذفه أولًا.",
    "RETENTION_RELEASED": "أُفرج عن محتجزات هذا المستخلص. ألغِ الإفراج أولًا.",
    "ADVANCE_EXISTS": "لهذا العقد فاتورة دفعة مقدمة بالفعل.",
    "ADVANCE_RECOVERED": "استُرد جزء من الدفعة المقدمة، فلا يمكن إلغاؤها.",
    "RETENTION_EXCEEDS_HELD": "هذا أكثر من المحتجزات القائمة.",
    "BILLING_BY_CLAIMS": "يُفوتر هذا المشروع بالمستخلصات فقط.",
    "GL_ROLE_LINES": "لا يمكن تعديل فاتورة عقد من المبيعات.",
    "CONTROL_ACCOUNT": "هذا حساب رقابة ولا يقبل قيودًا يدوية.",
    "ROLE_ACCOUNT_SHARED": "يحتاج كل دور من أدوار المقاولات إلى حساب خاص به.",
    "VERSION_CONFLICT": "غيّر شخص آخر هذا في الأثناء. أغلقه وافتحه من جديد لترى نسخته.",
    "PROJECT_FEATURE_OFF": "هذه الوظيفة متوقفة لهذا المشروع.",
    "PROJECT_NOT_OPEN": "المشروع مقفل أو ملغى.",
    "CONTRACT_NOT_SETTLED": "لا يمكن إغلاق العقد بعد: يوجد مستخلص مفتوح، أو محتجزات لم يُفرج عنها، أو دفعة مقدمة لم تُسترد أو تُخفَّض بالكامل، أو رقم يختلف عن دفتر الأستاذ.",
    "FORFEIT_EXCEEDS_HELD": "هذا أكثر من المحتجزات المتبقية.",
    "REDUCTION_EXCEEDS_OUTSTANDING": "هذا أكثر من المتبقي من الدفعة المقدمة.",
    "SIGNAL_NOT_ACTIVE": "لم يعد هذا التنبيه قائمًا، فلا شيء لتأجيله.",
    "GUARANTEE_CLOSED": "هذا الضمان مُفرج عنه أو مُسيَّل، فلا يمكن تغييره بعد الآن.",
    "GUARANTEE_EVENT_ORDER": "اجعل تاريخ الحدث في تاريخ إصدار الضمان وآخر أحداثه أو بعدهما، ولا يتجاوز اليوم."
  },
  "approval": {
    "waiting": "بانتظار الموافقة الداخلية",
    "byWorkflow": "يقرره مسار موافقة؛ والموافقة الأخيرة ترسله إلى العميل.",
    "fourEyes": "يوافق عليه هنا شخص آخر لديه صلاحية الموافقة على مستندات العقود، ثم يُقدَّم إلى العميل؛ أو يعيده إلى المسودة.",
    "selfApproval": "أنت من أرسله للموافقة، لذا يوافق عليه شخص آخر لديه صلاحية الموافقة على مستندات العقود.",
    "subject": {
      "variations": "الأمر التغييري",
      "claims": "المستخلص"
    },
    "approveTitle": "الموافقة على {{name}}؟",
    "approveBody": {
      "variations": "يُقدَّم إلى العميل كما هو: يُجمَّد، ويُسجَّل قرار العميل بعد ذلك.",
      "claims": "يُقدَّم إلى العميل: يأخذ رقم المستخلص التالي ويُجمَّد حتى يعتمده العميل."
    },
    "approveConfirm": "موافقة وتقديم",
    "approved": "تمت الموافقة على {{name}} وقُدِّم إلى العميل",
    "returnTitle": "إعادة {{name}} إلى المسودة",
    "returnBody": "يستطيع المُعِدّ تعديل {{what}} وإرساله من جديد، ويرى سببك.",
    "returnReason": "السبب",
    "returnConfirm": "إعادة إلى المسودة",
    "returned": "أُعيد {{name}} إلى المسودة",
    "send": "إرسال للموافقة",
    "sent": "أُرسل {{name}} للموافقة الداخلية",
    "approve": "موافقة",
    "return": "إعادة",
    "openRequest": "فتح طلب الموافقة",
    "notYours": "يوافق عليه فقط من لديه صلاحية الموافقة على مستندات العقود ولم يُعِدّه.",
    "returnedTitle": "أُعيد إلى المسودة",
    "returnedBy": "أعاده {{name}} في {{date}}: {{reason}}",
    "returnedOn": "أُعيد في {{date}}: {{reason}}",
    "claimName": {
      "INTERIM": "المستخلص المرحلي حتى {{date}}",
      "FINAL": "المستخلص الختامي"
    },
    "claimApproveTitle": {
      "INTERIM": "الموافقة على المستخلص المرحلي حتى {{date}}؟",
      "FINAL": "الموافقة على المستخلص الختامي؟"
    },
    "claimBody": "للعميل {{client}}: صافٍ قدره {{net}} قبل الضريبة، و{{total}} شاملًا الضريبة. الموافقة تقدّمه إلى العميل: يأخذ رقم المستخلص التالي ويُجمَّد حتى يعتمده العميل."
  },
  "final": {
    "needsActive": "يبدأ الحساب الختامي بعد تفعيل العقد.",
    "title": "الحساب الختامي",
    "asOf": "في {{date}}",
    "print": "طباعة الكشف",
    "close": "إغلاق العقد",
    "notClosable": "ينتظر إغلاق العقد تسوية كل شيء: {{list}}.",
    "identity": {
      "ADVANCES": "الدفعات المقدمة",
      "RETENTION": "المحتجزات",
      "REVENUE": "إيرادات العقود"
    },
    "identityOff": "{{identity}} تختلف عن دفتر الأستاذ بمبلغ {{amount}}.",
    "value": "قيمة العقد",
    "originalSum": "قيمة العقد الأصلية",
    "currentValue": "قيمة العقد النهائية",
    "certifiedGross": "الإجمالي المعتمد النهائي",
    "delayDamages": "غرامات التأخير",
    "retention": "المحتجزات",
    "held": "المحتجز",
    "released": "المُفرج عنه",
    "forfeited": "المتنازل عنه",
    "retentionBalance": "ما زال محتجزًا",
    "advance": "الدفعة المقدمة",
    "advanceInvoiced": "المفوتر",
    "advanceRecovered": "المسترد بالمستخلصات",
    "advanceReduced": "المخفّض بإشعار دائن",
    "advanceOutstanding": "المتبقي",
    "documents": "الفواتير والمقبوضات",
    "noDocuments": "لا توجد مستندات بعد.",
    "col": {
      "document": "المستند",
      "date": "التاريخ",
      "total": "الإجمالي",
      "received": "المقبوض",
      "balance": "الرصيد"
    },
    "kind": {
      "CLAIM": "شهادة دفع",
      "ADVANCE": "دفعة مقدمة",
      "RETENTION_RELEASE": "إفراج عن المحتجزات",
      "ADVANCE_REDUCTION": "تخفيض الدفعة المقدمة"
    },
    "balanceDue": "الرصيد المستحق على العميل",
    "balanceOwed": "الرصيد المستحق للعميل",
    "checks": "المطابقة مع دفتر الأستاذ",
    "differs": "فرق {{amount}}",
    "zero": "صفر",
    "closeTitle": "إغلاق عقد {{code}}؟",
    "closeBody": {
      "due": "يصبح العقد مغلقًا: لا مستخلصات ولا أوامر تغييرية ولا إفراجات أو تخفيضات جديدة. ما زال على العميل {{balance}}، ويبقى في المبيعات للتحصيل. إغلاق المشروع نفسه إجراء منفصل.",
      "owed": "يصبح العقد مغلقًا: لا مستخلصات ولا أوامر تغييرية ولا إفراجات أو تخفيضات جديدة. للعميل {{balance}}: رُدّه إليه أو قاصّه في المبيعات. إغلاق المشروع نفسه إجراء منفصل.",
      "settled": "يصبح العقد مغلقًا: لا مستخلصات ولا أوامر تغييرية ولا إفراجات أو تخفيضات جديدة. لا رصيد مستحق على أي من الطرفين. إغلاق المشروع نفسه إجراء منفصل."
    },
    "closeConfirm": "إغلاق العقد",
    "closed": "أُغلق عقد {{code}}",
    "back": "العودة إلى {{code}}",
    "printTitle": "كشف الحساب الختامي",
    "asOfLabel": "في تاريخ",
    "contractNo": "رقم العقد",
    "clientRef": "مرجع العميل",
    "client": "العميل",
    "project": "المشروع",
    "unsettled": {
      "claims": "يوجد مستخلص مفتوح: اعتمده أو ارفضه أو احذفه",
      "retention": "ما زالت محتجزات بمبلغ {{amount}}: أفرج عنها أو تنازل عنها",
      "advance": "ما زال من الدفعة المقدمة {{amount}} لم يُسترد: استرده أو خفّضه",
      "openSubmitted": "المستخلص {{number}} ما زال مفتوحًا: اعتمده أو ارفضه",
      "openDraft": "مسودة المستخلص حتى {{date}} ما زالت مفتوحة: قدّمها أو احذفها",
      "openPending": "المستخلص حتى {{date}} بانتظار الموافقة الداخلية: وافق عليه أو أعده إلى المسودة"
    },
    "valueToDate": "قيمة العقد حتى تاريخه",
    "printDraft": "مسودة: العقد لم يُغلق بعد",
    "draftStamp": "مسودة"
  },
  "progress": {
    "title": "تقدم العقد",
    "hint": "العقد دون مبالغ: تحتاج المبالغ صلاحية إدارة عقود المشاريع أو عرض أموال المشاريع.",
    "commencement": "تاريخ البدء",
    "completionDue": "موعد الإنجاز",
    "practicalCompletion": "الإنجاز الفعلي",
    "dlpEnd": "نهاية فترة ضمان العيوب",
    "variations": "الأوامر التغييرية",
    "noVariations": "لا توجد أوامر تغييرية.",
    "noTime": "دون أثر على المدة",
    "claims": "المستخلصات",
    "noClaims": "لا توجد مستخلصات بعد.",
    "draftClaim": "مستخلص مسودة",
    "periodTo": "الفترة حتى {{date}}",
    "certifiedOn": "اعتُمد {{date}}",
    "boq": "جدول الكميات: المعتمد حتى تاريخه",
    "noBoq": "لا يوجد جدول كميات للعقد بعد.",
    "item": "البند",
    "description": "الوصف",
    "quantity": "الكمية",
    "certified": "المعتمد",
    "certifiedOf": "المعتمد من البند {{item}}"
  }
}
